<script setup lang="ts">
  import { computed } from 'vue';
  import {
    mpfAttachmentListDefaults,
    type MpfAttachmentListProps,
  } from './MpfAttachmentList.props';

  const props = withDefaults(defineProps<MpfAttachmentListProps>(), mpfAttachmentListDefaults);

  const opensInNewTab = computed(() => props.target === '_blank');

  const resolvedHeading = computed(
    () => props.heading ?? (props.items.length === 1 ? 'Attachment' : 'Attachments'),
  );
</script>

<template>
  <div v-if="items.length" class="mpf-attachment-list">
    <component :is="`h${props.headingLevel}`" class="mpf-attachment-list__heading">{{
      resolvedHeading
    }}</component>
    <ul class="mpf-attachment-list__items">
      <li
        v-for="(item, index) in items"
        :key="`${item.href}-${index}`"
        class="mpf-attachment-list__item"
      >
        <a
          class="mpf-link"
          :href="item.href"
          :target="target"
          :rel="opensInNewTab ? 'noopener noreferrer' : undefined"
          data-private
          >{{ item.fileName || fallbackFileName
          }}<span v-if="opensInNewTab" class="mpf-u-visually-hidden"> (opens in a new tab)</span></a
        >
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
  @use './MpfAttachmentList.scss';
</style>
